// extracted by mini-css-extract-plugin
export default {"textStyle":"styles_textStyle__WOy8M","strongerText":"styles_strongerText__DGIlf"};